import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device_todo",
  "use": "device_todo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"device_todo\"><path d=\"M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0zm-1.5 0a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0zM7.25 5.75v2.5c0 .054.006.107.017.158a.75.75 0 0 0 .374.617l2.165 1.25a.75.75 0 1 0 .75-1.3L8.75 7.933V5.75a.75.75 0 0 0-1.5 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol